import { make } from "vuex-pathify";
import LoanSettingsService from "@/modules/loanpro/services/loan-settings.service";
import { LoanReviewChecklistService } from "@/modules/global-settings/loan-origination/services/loan-policies/loan-review-checklist.service";
import { incomeAndExpenseTypeService } from "@/modules/global-settings/loan-origination/services/other-settings/income-and-expenditure-type.service";

const loanSettingsService = new LoanSettingsService();
const loanReviewChecklistService = new LoanReviewChecklistService();
const personAccountTypeService = new incomeAndExpenseTypeService();

export const state = {
  generalSettings: {},
  riskFactors: [],
  creditRatings: [],
  dsrRatings: [],
  networthRatings: [],
  dsrCalculationMethods: [],
  deviations: [],
  loanStoppers: {},
  yapuSettings: {},
  branches: {},

  incomeTypes: [],
  expenseTypes: [],
  statutoryDeductionTypes: [],
  nonStatutoryDeductionTypes: [],
  deductionTypes: [],
  assetTypes: [],
  liabilityTypes: [],

  loanProducts: [],
  loanTypes: [],
  paymentFrequencies: [],
  branches: [],
  checklistItems: [],
};


export const getters = {
  ...make.getters(state),
};

export const mutations = {
  ...make.mutations(state),
};

export const actions = {
  async loadSettings({ dispatch }) {
    const modules = [
      "loanSettingsModule/fetchBranches",
      "loanSettingsModule/fetchDSRCalculateMethods",
      "loanSettingsModule/fetchGeneralSettings",
      "loanSettingsModule/fetchLoanTypes",
      "loanSettingsModule/fetchChecklistItems",
      "loanSettingsModule/fetchAccountTypes",
      "loanSettingsModule/fetchRiskFactors",
      "loanSettingsModule/fetchLoanProducts",
    ];
    await Promise.all(modules.map((el) => dispatch(el, null, { root: true })));
  },

  async fetchGeneralSettings({ commit }) {
    const { data } = await loanSettingsService.getGeneralLoanSettings();
    
    commit("SET_DSR_RATINGS", data?.limits?.dsrRatings || []);
    commit("SET_NETWORTH_RATINGS", data?.limits?.networkRatings || []);
    commit("SET_CREDIT_RATINGS", data?.limits?.creditScoreRatings || []);
    commit("SET_PAYMENT_FREQUENCIES", data?.frequencies || []);
    commit("SET_DEVIATIONS", data?.deviations || []);
    commit("SET_LOAN_STOPPERS", data?.loanStoppers || {});
    commit("SET_YAPU_SETTINGS", data?.yapu || {});
    commit("SET_GENERAL_SETTINGS", data?.general || {});
  },

  async fetchLoanTypes({ commit }) {
    const { data } = await loanSettingsService.getLoanTypes();
    commit("SET_LOAN_TYPES", data || []);
    return data;
  },
  
  async fetchChecklistItems({ commit }) {
    const { data } = await loanReviewChecklistService.fetchChecklists();
    commit("SET_CHECKLIST_ITEMS", data || []);
  },

  async fetchLoanProducts({ commit, getters }) {
    const { data } = await loanSettingsService.getLoanProducts();
    const products = data.map((el) => {
      const loanTypeDetails= getters.loanTypes.find(e => e.id === el.loanTypeRef);
      const checklist = getters.checklistItems?.filter((e) => !!el.checklistRef.find(id => e.id === id) )
      
        return {
          ...el,
          loanTypeDetails,
          checklist 
        }
      }
    )
    commit("SET_LOAN_PRODUCTS", products || []);
  },

  async fetchBranches({ commit }) {
    const { data } = await loanSettingsService.getBranches();
    commit("SET_BRANCHES", data || []);
  },

  async fetchRiskFactors({ commit }) {
    const { data } = await loanSettingsService.getRiskFactors();
    commit("SET_RISK_FACTORS", data || []);
  },

  async fetchDSRCalculateMethods({ commit }) {
    const { data } = await loanSettingsService.getCalculationMethods();
    commit("SET_DSR_CALCULATION_METHODS", data);
  },

  async fetchAccountTypes({ commit }) {
    const assets = [];
    const incomes = [];
    const expenses = [];
    const deductions = [];
    const liabilities = [];
    const nonStatutoryDeductions = [];
    const statutoryDeductions = [];

    const { data } = await personAccountTypeService.getIncAndExpTypes();
    data.forEach((el) => {
      switch (el.accountType) {
        case "Income":
          incomes.push(el);
          break;
        case "Expense":
          expenses.push(el);
          break;
        case "Asset":
          assets.push(el);
          break;
        case "Liability":
          liabilities.push(el);
          break;
        default:
          if (el.deductionType == "Statutory") {
            statutoryDeductions.push(el);
          } else {
            nonStatutoryDeductions.push(el);
          }
          deductions.push(el);
      }
    });

    commit("SET_ASSET_TYPES", assets);
    commit("SET_INCOME_TYPES", incomes);
    commit("SET_EXPENSE_TYPES", expenses);
    commit("SET_LIABILITY_TYPES", liabilities);
    commit("SET_DEDUCTION_TYPES", deductions);
    commit("SET_NON_STATUTORY_DEDUCTION_TYPES", nonStatutoryDeductions);
    commit("SET_STATUTORY_DEDUCTION_TYPES", statutoryDeductions);
  },
};
